/* @flow */

import Hashids from 'hashids';

/**
 * A class wrapper around hashids - handles unique-to-project-name id generation.
 * https://github.com/ivanakimov/hashids.js
 *
 * @export
 * @class HashId
 */

type ConfigType = {
  chars: string,
  length: number,
  name: string,
};

const baseConfig: ConfigType = {
  name: `"${process.env.REACT_APP_TOOL_NAME}"`,
  length: 8,
  chars: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890',
};

class HashId {
  count: number;
  hashids: typeof Hashids;
  ids: Array<string> = [];

  static instance: HashId;
  static nextId: () => string;

  constructor(config: ConfigType = baseConfig): HashId {
    const instanceConfig = Object.assign({}, baseConfig, config);

    if (!HashId.instance) {
      HashId.instance = this;
      this.hashids = new Hashids(instanceConfig.name, instanceConfig.length, instanceConfig.chars);
      this.count = 0;
      this.ids = [];
    }
    return HashId.instance;
  }
  /**
   * Returns the next id
   *
   * @returns {string}
   * @memberOf HashId
   */
  nextId(): string {
    this.count += 1;
    const id = this.hashids.encode(this.count);
    this.ids = [].concat(this.ids, id);
    return id;
  }
}

export default HashId;



// WEBPACK FOOTER //
// ./src/utils/hashid.js